/*
 * Marketplace specific configuration.
 */

import insuranceLogo from '../src/assets/insuranceLogo.svg';

export const country = 'es';

export const mailContact = 'hola@swimmy.es';

export const pressMail = 'presse@swimmy.fr';
export const pressPhoneNumber = '+34910783228';
export const pressPhoneNumberReadable = '+34 91 078 32 28';

export const supportPhoneNumber = '+34910783228';
export const supportPhoneNumberReadable = '+34 91 078 32 28';

export const providersSupportPhoneNumber = '+34910783228';
export const providersSupportPhoneNumberReadable = '+34 91 078 32 28';

export const teamBuildingMail = 'hola@swimmy.es';
export const birthdayMail = 'hola@swimmy.es';

export const supportHours = {
  start: '10:00',
  end: '18:00',
};

export const hasZendeskWidget = true;

export const hasBlog = true;
export const blogUrl = 'https://blog.swimmy.es/';

export const hasInsurance = true;
export { insuranceLogo };

export const hasSecurityLaw = false;
export const securityRulesURL = 'https://www.swimmy.es/security-rules';
export const securityOptions = [
  { key: 'barriereDeProtection', label: 'Barrera protectora' },
  { key: 'bacheDeSecurite', label: 'Lona de seguridad' },
  { key: 'abriDePiscine', label: 'Cerramiento de piscina' },
  { key: 'alarmeDeSecurite', label: 'Alarma de seguridad' },
];

// this is used to toggle reviews on LandingPage/SimulatorPage
export const showReviews = true;

export const showPressArticles = true;

export const stripeIdentityDocuments = [
  'Pasaporte',
  'Licencia de conducir - anverso y reverso',
  'Tarjeta de identidad - anverso y reverso',
];

export const stripeAddressDocuments = [
  'Factura de teléfono - con fecha de menos de 6 meses',
  'Factura de luz, gas o agua - con fecha inferior a 6 meses',
  'Certificado o factura de seguro de vivienda - con fecha inferior a 6 meses',
  'Título de propiedad',
];

export const eventQuery =
  '?address=Espagne&bounds=45.244%2C5.098%2C35.17300000000001%2C-12.524&origin=40.46366700000001%2C-3.74922&country=ES';

export const amenities = [
  { key: 'wifi', label: '💻 Wi-Fi' },
  { key: 'piscine_interieure', label: '🏊 Piscina interior' },
  { key: 'piscine_chauffee', label: '🌡️ Piscina climatizada' },
  { key: 'piscine_exterieure', label: '🏊‍♂️ Piscina exterior' },
  { key: 'douche', label: '🚿 Ducha' },
  { key: 'toilette', label: '🚽 Baños' },
  { key: 'jacuzzi', label: '🛁 Jacuzzi' },
  { key: 'sauna', label: '🧖 Sauna' },
  { key: 'jardin', label: '☀️ Jardín' },
  { key: 'transats', label: '⛱️ Tumbonas' },
  { key: 'table_et_chaises', label: '🪑 Mesa y sillas' },
  { key: 'bbq', label: '🍖 Barbacoa' },
  { key: 'bouées', label: '🤽 Flotadores' },
  { key: 'jeux', label: '🥏 Juegos al aire libre' },
  { key: 'tennis', label: '🎾 Tenis' },
  { key: 'petanque', label: '🎯 Campo de petanca' },
];

export const validExtras = ['barbecueFee', 'towelsFee', 'jacuzziFee', 'snackFee'];

export const paidExtras = [
  {
    data: {
      amount: 1000,
      currency: 'EUR',
      id: 'barbecueFee',
      isByUnit: false,
      information:
        'Puedes proponer tu barbacoa por 10€ por alquiler. Te comprometes a propoporcionar el carbón si es necesario.',
    },
    key: 'barbecueFee',
    label: '🍖 Barbacoa • 10€',
  },
  {
    data: {
      amount: 300,
      currency: 'EUR',
      id: 'towelsFee',
      isByUnit: true,
      information: 'Puedes proponer una toalla por 3€/toalla.',
    },
    key: 'towelsFee',
    label: '🧺 Toalla • 3€/persona',
  },
  {
    data: { amount: 1000, currency: 'EUR', id: 'jacuzziFee', isByUnit: true },
    key: 'jacuzziFee',
    label: '🛁 Spa / Jacuzzi • 10€/persona',
  },
  {
    data: {
      amount: 400,
      currency: 'EUR',
      id: 'snackFee',
      isByUnit: true,
      information:
        'Puedes proponer una merienda/picoteo por 4€/persona. Puedes añadirlo a la descripción de tu anuncio.',
    },
    key: 'snackFee',
    label: '🥤 Merienda • 4€/persona',
  },
];

export const providerPresentOptions = [
  { key: 'oui', label: 'Sí' },
  { key: 'non', label: 'No' },
  { key: 'occasionnellement', label: 'De vez en cuando' },
];

export const getOverLookedEditListing = (intl) => [
  {
    label: intl.formatMessage({ id: 'EditListingForm.OverLookedNo' }),
    key: 'OverLookedNo',
  },
  {
    label: intl.formatMessage({ id: 'EditListingForm.OverLookedYesLight' }),
    key: 'OverLookedYesLight',
  },
  {
    label: intl.formatMessage({ id: 'EditListingForm.OverLookedYes' }),
    key: 'OverLookedYes',
  },
];

export const getDeclineReasons = (intl) => [
  {
    label: intl.formatMessage({ id: 'DeclineReason.BadWeatherCondition' }),
    key: 'badWeatherCondition',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.PoolNotAvailable' }),
    key: 'poolNotAvailable',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.Other' }),
    key: 'other',
  },
];

export const getDeclineByProviderReasons = (intl) => [
  {
    label: intl.formatMessage({ id: 'DeclineReason.TooLateRequest' }),
    key: 'tooLateRequest',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.OwnerPersonalUse' }),
    key: 'ownerPersonalUse',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.OwnerNotAvailable' }),
    key: 'ownerNotAvailable',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.LowBookingAmount' }),
    key: 'lowBookingAmount',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.MultipleRequests' }),
    key: 'multipleRequests',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.TenantAskedToCancel' }),
    key: 'tenantAskedToCancel',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.UntrustedProfile' }),
    key: 'untrustedProfile',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.Other' }),
    key: 'other',
  },
];

export const getCancelByProviderReasons = (intl) => [
  {
    label: intl.formatMessage({ id: 'DeclineReason.BadWeatherCondition' }),
    key: 'badWeatherCondition',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.NoAnswerFromCustomer' }),
    key: 'noAnswerFromCustomer',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.OwnerPersonalUse' }),
    key: 'ownerPersonalUse',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.TenantAskedToCancel' }),
    key: 'customerAskedToCancel',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.UntrustedProfile' }),
    key: 'untrustedProfile',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.Other' }),
    key: 'other',
  },
];

export const howDidYouKnowUsOptions = [
  { key: 'wordOfMouth', label: 'De boca en boca' },
  { key: 'medias', label: 'Medios de Comunicación' },
  { key: 'bySwimmyTeamContact', label: 'He sido contactado(a) por el equipo Swimmy' },
  { key: 'byFacebook', label: 'Facebook' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'postcard', label: 'Recibí una postal' },
  { key: 'byAds', label: 'Vi un anuncio en internet' },
  { key: 'bySwimmyBlog', label: 'El Blog de Swimmy' },
  { key: 'other', label: 'Otros' },
];

export const customerCommissionPercentage = 20;

export const childrenDiscountMultiplier = 0.5;

export const customBoundsMultiplier = {};

export const filters = [
  {
    id: 'price',
    label: 'Precio',
    type: 'PriceFilter',
    group: 'primary',
    queryParamNames: ['price'],
    config: {
      min: 1,
      max: 500,
      step: 1,
    },
  },
  {
    id: 'superHost',
    label: 'Filter.superHostLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_isHostedBySuperHost'],
    config: {
      helper: 'Filter.superHostHelper',
    },
  },
  {
    id: 'suitableForChildren',
    label: 'Filter.suitableForChildrenLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_enfantsBienvenue'],
    config: {
      helper: 'Filter.suitableForChildrenHelper',
    },
  },
  {
    id: 'policyEvent',
    label: 'Filter.policyEventLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyEvent'],
    config: {
      helper: 'Filter.policyEventHelper',
    },
  },
  {
    id: 'policyMusic',
    label: 'Filter.policyMusicLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyMusic'],
    config: {
      helper: 'Filter.policyMusicHelper',
    },
  },
  {
    id: 'policyPets',
    label: 'Filter.policyPetsLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyPets'],
    config: {
      helper: 'Filter.policyPetsHelper',
    },
  },
  {
    id: 'policyAlcohol',
    label: 'Filter.policyAlcoholLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyAlcohol'],
    config: {
      helper: 'Filter.policyAlcoholHelper',
    },
  },
  {
    id: 'policySmoking',
    label: 'Filter.policySmokingLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policySmoking'],
    config: {
      helper: 'Filter.policySmokingHelper',
    },
  },
  {
    id: 'burkiniAllowed',
    label: 'Filter.burkiniLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_burkiniAllowed'],
    config: {
      helper: 'Filter.burkiniHelper',
    },
  },
  {
    id: 'naturistAllowed',
    label: 'Filter.naturismLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_naturistAllowed'],
    config: {
      helper: 'Filter.naturismHelper',
    },
  },
  {
    id: 'amenities',
    label: 'Equipamientos',
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_extras'],
    config: {
      searchMode: 'has_all',
      options: amenities,
    },
  },
];

export const sortConfig = {
  active: false,
  queryParamName: 'sort',
  relevanceKey: 'relevance',
  conflictingFilters: ['keyword'],
  options: [
    { key: 'createdAt', label: 'Newest' },
    { key: '-createdAt', label: 'Oldest' },
    { key: '-price', label: 'Lowest price' },
    { key: 'price', label: 'Highest price' },
    { key: 'relevance', label: 'Relevance', longLabel: 'Relevance (Keyword search)' },
  ],
};

export const distanceUnit = 'km';

export const isSeasonalMarketplace = true;
export const seasonStart = {
  month: 'Marzo',
  value: 2,
};
export const seasonEnd = {
  month: 'Octubre',
  value: 9,
};

export const marketplaceAgeRequirement = 18;

export const minStartHourToBook = 9;

export const simulatorFormLocations = [
  { key: 3000, label: 'Comunidad Autónoma de Madrid' },
  { key: 3000, label: 'Comunidad Autónoma de Cataluña' },
  { key: 2200, label: 'Comunidad Autónoma de Andalucia' },
  { key: 2000, label: 'Otras Comunidades Autónomas' },
];

export const withEveningBookingModeDate = '2021-04-13T15:30:00.000Z';

export const insuranceSlug = 'roots?slug=insurance-es';

export const faqSlug = 'roots?slug=faq-es';

export const termsOfUseSlug = 'roots?slug=terms-of-use-es';

export const helpCenterUrl = 'https://help.swimmy.com/hc/es';
export const helpCenterUrlForCustomers =
  'https://help.swimmy.com/hc/es/categories/360002484820-Soy-un-inquilino';
export const helpCenterUrlForProviders =
  'https://help.swimmy.com/hc/es/categories/360002499219-Soy-propietario';

export const legalNoticeSlug = 'roots?slug=legal-notice-es';

export const appStoreLink =
  'https://apps.apple.com/es/app/swimmy-location-de-piscines/id1553975232';
export const playStoreLink =
  'http://play.google.com/store/apps/details?id=com.swimmy.swimmy&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
export const openTicketLink = 'https://help.swimmy.com/hc/es/requests/new';

export const MIN_TOTAL_FOR_PROPOSAL = 50000;
